// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"47f2d336","469":"b9baa70d"}[chunkId] + ".chunk.css";
};